import React from "react";
import { Square6Style } from "./css/Square6Style";
import TemplateImage from "../../components/editor/Templates/TemplateImage";
import TemplateLogo from "../../components/editor/Templates/TemplateLogo";
import TemplateWatermark from "../../components/editor/Templates/TemplateWatermark";
import TemplateText from "../../components/editor/Templates/TemplateText";

const Template = (props) => {
  return (
    <Square6Style>
      <div className="poster one-by-one lg flex-column">
        <TemplateLogo logo={props.logo} />
        <TemplateWatermark watermark={props.watermark} />
        <div className="overlay black" />
        <div className="overlay white" />
        <div className="overlay blue" />
        <div className="text-wrapper flex-column">
          <TemplateText
            id={props.id}
            text={props.text}
            textStyle={props.textStyle}
            editStatus={props.editStatus}
            onInputSlideText={props.onInputSlideText}
          />
        </div>
        <div className="video-outer">
          <div className="video-container">
            <TemplateImage slideType={props.slideType} file={props.file} />
          </div>
        </div>
      </div>
    </Square6Style>
  );
};

export default Template;
